export default {
  namespaced: true,
  state: {
    username: localStorage.getItem('username'),
    role: parseInt(localStorage.getItem('role')),
    token: localStorage.getItem('username'),
    uid: localStorage.getItem('uid'),
    is_admin: localStorage.getItem('is_admin'),
    companyId: localStorage.getItem('companyId'),
	platform_type: localStorage.getItem('platform_type'),
  },
  mutations: {
    changeBaseInfo(state, { uid, is_admin, username, role, token, companyId,platform_type }) {
      state.username = username;
      state.role = role;
      state.token = token;
      state.uid = uid;
      state.is_admin = is_admin;
      state.companyId = companyId;
	   state.platform_type = platform_type;
	  
    },
	
  },
  actions: {
    saveBaseInfo(context, val) {
      context.commit('changeBaseInfo', val);
    },
  },
};
